import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { SUPPORT_WHATSAPP_LINK } from "../lib/constants";
import { PackageOpen } from "lucide-react";

// actions: [{ label, to?, href?, variant?, testid }]
export const EmptyStateCTA = ({ title, subtitle, actions = [], testid = "empty-state-cta", icon: Icon = PackageOpen }) => (
  <div className="border border-dashed border-border bg-white p-10 sm:p-16 text-center" data-testid={testid}>
    <div className="mx-auto h-12 w-12 bg-muted flex items-center justify-center mb-5">
      <Icon className="h-6 w-6 text-primary" />
    </div>
    <p className="font-display font-bold text-xl sm:text-2xl tracking-tight max-w-2xl mx-auto">{title}</p>
    {subtitle && <p className="text-sm text-muted-foreground mt-3 max-w-xl mx-auto">{subtitle}</p>}
    <div className="flex flex-wrap gap-3 justify-center mt-8">
      {actions.map((a) =>
        a.onClick ? (
          <Button key={a.label} onClick={a.onClick} data-testid={a.testid} variant={a.variant === "primary" ? "default" : "outline"} className={`rounded-none h-11 px-6 ${a.variant === "primary" ? "bg-primary hover:bg-primary/90" : "border-foreground"}`}>{a.label}</Button>
        ) : a.href ? (
          <a key={a.label} href={a.href} target="_blank" rel="noopener noreferrer" data-testid={a.testid}>
            <Button variant={a.variant || "outline"} className={`rounded-none h-11 px-6 ${a.variant === "whatsapp" ? "bg-[#25D366] hover:bg-[#1da851] text-white border-0" : "border-foreground"}`}>{a.label}</Button>
          </a>
        ) : (
          <Link key={a.label} to={a.to} data-testid={a.testid}>
            <Button variant={a.variant === "primary" ? "default" : a.variant || "outline"} className={`rounded-none h-11 px-6 ${a.variant === "primary" ? "bg-primary hover:bg-primary/90" : "border-foreground"}`}>{a.label}</Button>
          </Link>
        )
      )}
    </div>
  </div>
);

export const SUPPORT_WHATSAPP = SUPPORT_WHATSAPP_LINK;
